import React from 'react';
import "./NotFound.style.css"

const NotFoundPage = () => {
    return (
        <div className="container">
            <div className="text-center not-found">
                Ой, а тут ничего нет, но скоро будет :)
            </div>
        </div>
    );
};

export default NotFoundPage;